import { noop } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withHandlers, withProps, withState } from 'recompose';
import { head } from 'ramda';
import withBaseUrl from '../../hoc/withBaseUrl';
import withNotifications from '../../../common/withNotifications';
import { bindActionsForRoles } from '../../../common/helpers/actions';
import { importShopSubscriptions, importBrandSubscriptions } from '../actions';
import withOwnerTypeAndId from '../../../common/hoc/withOwnerTypeAndId';
import { activeShopEmail } from '../../../auth/selectors';
import withToggle from '../../../common/hoc/withToggle';
import { t } from '../../../../modules/infra/i18n';

const ImportSubscriptionsFormContainer = compose(
  withRouter,
  withOwnerTypeAndId,
  withToggle('email'),
  connect(
    state => ({
      defaultEmail: activeShopEmail(state),
    }),
    dispatch => ({
      importSubscriptions: bindActionsForRoles(dispatch, importShopSubscriptions, noop, importBrandSubscriptions),
    }),
  ),
  withBaseUrl,
  withState('busy', 'setBusy', false),
  withNotifications,
  withState('membership', 'setMembership', props => props.membership),
  withState('busy', 'setBusy', false),
  withState('csv', 'setCsv', false),
  withProps(props => ({
    submitDisabled: props.busy || !props.csv,
  })),
  withHandlers({
    onSubmit: props => (data) => {
      props.emailOff();
      props.setBusy(true);
      const { csv, ownerId, ownerType } = props;
      props.importSubscriptions[ownerType](ownerId, csv, data)
        .then(({ message }) => {
          props.router.push(props.baseUrl);
          props.addNotification({
            level: 'success',
            title: t('common:success_title'),
            message,
          });
        }).catch()
        .finally(() => {
          props.setBusy(false);
        });
    },
  }),
  withHandlers({
    onChange: props => (e) => {
      props.setCsv(head(e.target.files));
      e.target.value = null;
      props.emailOn();
    },
  }),
);

export default ImportSubscriptionsFormContainer;
